import styled from 'styled-components';

import { Text } from '~/components/ui/Text';
import { Popup } from '../Popup';

const StyledContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledLeftContainer = styled.div`
	display: flex;
	align-items: center;
	column-gap: 20px;
	pointer-events: none;
`;

const StyledRightContainer = styled.div`
	display: flex;
	align-items: center;
	column-gap: 40px;
`;

const StyledCreateDepositButtonContainer = styled.div`
	// display: flex;
	align-items: center;
	column-gap: 10px;
	height: 40px;
	padding: 0 10px;
	border-radius: 10px;
	background: rgba(255, 255, 255, 0.05);
	cursor: pointer;

	// в данной итерации скрыто
	display: none;
`;

const StyledCloseButtonContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 40px;
	height: 40px;
	border-radius: 10px;
	background-color: rgba(255, 255, 255, 0.1);

	transition: background-color 0.3s ease;

	&:hover {
		background-color: #ffffff;

		img {
			filter: invert(100%);
		}
	}

	img {
		transition: filter 0.3s ease;
		pointer-events: none;
	}
`;

const StyledPopup = styled(Popup)`
	position: absolute;
	top: 110px;
	transform: translateX(-30px);
`;

const StyledImg = styled.img`
	transition: opacity 0.25s ease;

	&.menu-enter {
		opacity: 0;
	}

	&.menu-enter-active,
	&.menu-enter-done,
	&.menu-exit {
		opacity: 1;
	}

	&.menu-exit-active {
		opacity: 0;
	}
`;

const StyledTextLabel = styled(Text)`
	font-size: 20px;
	font-weight: 400;
	color: #ffffff;
	transition: opacity 0.25s ease;

	&.menu-enter {
		opacity: 0;
	}

	&.menu-enter-active,
	&.menu-enter-done,
	&.menu-exit {
		opacity: 1;
	}

	&.menu-exit-active {
		opacity: 0;
	}
`;

export {
	StyledCloseButtonContainer,
	StyledContainer,
	StyledCreateDepositButtonContainer,
	StyledImg,
	StyledLeftContainer,
	StyledPopup,
	StyledRightContainer,
	StyledTextLabel,
};
